export default __webpack_public_path__ + "static/media/account-white.1be380c8.svg";